import { ChangeDetectionStrategy, Component, Input, TemplateRef, ViewEncapsulation } from '@angular/core';
import { PhxSelectOptionContext } from './select.types';
import { PHX_SELECT_OPTION_TOKEN } from './select.token';

@Component({
  selector: 'phx-select-option',
  template: `<ng-container></ng-container>`,
  providers: [
    {
      provide: PHX_SELECT_OPTION_TOKEN,
      useExisting: PhxOptionComponent,
    },
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhxOptionComponent {
  @Input() public label: string;
  @Input() public subText: string;
  @Input() public value: any;
  @Input() public groupLabel: string;
  @Input() public isDivider: boolean;
  @Input() public isLink: boolean;
  @Input() public data: any;
  @Input() public disabled: boolean;
  @Input() public prefixIcon: string;
  @Input() public tooltip: string | TemplateRef<any>;
  @Input() public phxOptionTemplate: TemplateRef<{ $implicit: PhxSelectOptionContext }>;
  @Input() public suffixTemplate: TemplateRef<any> | null;
}
